import type { MenuItem } from '$lib/app/header/types/menu-item.type'

export const CORE_MENU_ITEMS: MenuItem[] = [
	{
		title: 'Home',
		href: '/'
	},
	{
		title: 'Docs',
		href: '/docs'
	},
	{
		title: 'Pricing',
		href: '/#pricing'
	},
	{
		title: 'Reach out',
		href: '/reach-out'
	},
	{
		title: 'Premium Sheets',
		href: '/premium'
	}
]

export const MOBILE_MENU_ITEMS = (isLoggedIn?: boolean, isSubscribed?: boolean): MenuItem[] => {
	return [...CORE_MENU_ITEMS, ...getMenuItems(isLoggedIn, isSubscribed)]
}

const getMenuItems = (isLoggedIn?: boolean, isSubscribed?: boolean) => {
	if (isLoggedIn && isSubscribed) {
		return [{ title: 'Account', href: '/account' }]
	} else if (isLoggedIn) {
		return [
			{ title: 'Account', href: '/account' },
			{ title: 'Get started', href: '/#pricing' }
		]
	}

	return [
		{
			title: 'Get started',
			href: '/sign-in'
		},
		{
			title: 'Sign in',
			href: '/sign-in'
		}
	]
}
